export default function getOffset(e: HTMLElement): { top: number, left: number } {
  if (e.getBoundingClientRect) {
    const box = e.getBoundingClientRect()
    const { body } = document
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || body.scrollTop
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || body.scrollLeft
    const clientTop = document.documentElement.clientTop || body.clientTop || 0
    const clientLeft = document.documentElement.clientLeft || body.clientLeft || 0
    return {
      top: Math.round(box.top + scrollTop - clientTop),
      left: Math.round(box.left + scrollLeft - clientLeft),
    }
  }
  let top = 0
  let left = 0
  let ce = e
  while (ce) {
    top += ce.offsetTop
    left += ce.offsetLeft
    ce = ce.offsetParent as HTMLElement
  }
  return {
    top: Math.round(top),
    left: Math.round(left),
  }
}
